"use client";

import styles from "./AuthorizePageContainer.module.scss";
import { ReactNode } from "react";

/**
 * AuthorizePageContainer Component
 *
 * Wrapper component for main authorize content area.
 * Provides styling and layout structure for authorize form and banner.
 */
export const AuthorizePageContainer = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <div className={styles["comp"]}>{children}</div>;
};
